import React from "react";
import styled from "styled-components";
import { AppText, FlexDiv } from "../../../ui";
import { LottieVideo } from "../../Segments";
import theme from "../../../../util/theme";
import { mobileSize } from "../../../../util/variables";

interface AnimationQuestionProps {
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  asset: string;
  hardcode?: boolean;
}

const AnimationQuestion: React.FC<AnimationQuestionProps> = ({ title, subtitle, asset, hardcode }) => {
  return (
    <FlexDiv direction="column" align="center" style={{ width: "100%" }}>
      {(title || subtitle) && (
        <TextWrapper>
          {title && <AppText fontSize={24} mobileFontSize={22} fontWeight={subtitle ? 500 : 400} style={{ maxWidth: 468, marginBottom: subtitle ? 12 : 24, lineHeight: 1.25 }}>{title}</AppText>}
          {subtitle && <AppText fontSize={20} mobileFontSize={18} style={{ maxWidth: 468, marginBottom: 24 }}>{subtitle}</AppText>}
        </TextWrapper>
      )}
      <AnimWrapper hasText={!!title || !!subtitle} hasBoth={!!title && !!subtitle} hardcode={hardcode}>
        <LottieVideo lottieJSON={asset} />
      </AnimWrapper>
    </FlexDiv>
  );
};

const AnimWrapper = styled(FlexDiv as any).attrs({
  align: "center", 
  justify: "center",
}) <{ hasText: boolean; hasBoth: boolean; hardcode: boolean }>`
  /* width: 100%; */
  height: ${props => {
    if (props.hasText) return "50dvh";
    return "65dvh";
  }};
  margin-top: ${props => (props.hardcode ? "-32px" : "48px")};
  @media ${mobileSize} {
    height: ${props => {
      if (props.hasBoth) return "40dvh";
      if (props.hasText) return "50dvh";
      return "65dvh";
    }};
    margin-top: ${props => (props.hardcode ? "-32px" : "8px")};
  }
`;

const Text = styled(AppText as any)`
  font-size: 24px;
  line-height: 34px;
  max-width: 468px;
  b {
    color: ${theme.PRIMARY_COLOR};
  }

  @media ${mobileSize} {
    font-size: 20px;
    line-height: 28px;
  }
`;

const TextWrapper = styled.div`
  padding: 0 4px;
  text-align: center;
`;

export default AnimationQuestion;
